import React, { FC, ReactNode } from 'react';
import cx from 'classnames';
import { ArticleHeaderDotSeparator } from './ArticleHeaderDotSeparator';

type TArticleHeaderInfoDetailsElementProps = {
  children: ReactNode;
  isFirst?: boolean;
  isSecond?: boolean;
};

const ArticleHeaderInfoDetailsElement: FC<TArticleHeaderInfoDetailsElementProps> = ({
  children,
  isFirst,
  isSecond,
}) => (
  <>
    <div
      className={cx('flex', {
        hidden: isFirst,
        'hidden xs:block': isSecond,
      })}
    >
      <ArticleHeaderDotSeparator />
    </div>

    <div className={cx('flex', { 'w-full justify-center xs:w-fit': isFirst })}>{children}</div>
  </>
);

export default ArticleHeaderInfoDetailsElement;
